import { useState, useEffect } from 'react';
import { API_CONFIG, API_ENDPOINTS } from '../config/api';
import { getAccessToken } from '../utils/authStorage';

/**
 * Hook para obter a data de renovação da assinatura ativa.
 * Usado no CreditExhaustedModal para exibir quando os créditos serão renovados.
 */
export function useSubscriptionForRenewalDate(): string | null {
  const [renewalDate, setRenewalDate] = useState<string | null>(null);

  useEffect(() => {
    const loadSubscription = async () => {
      try {
        const token = getAccessToken();
        const response = await fetch(`${API_CONFIG.BASE_URL}${API_ENDPOINTS.SUBSCRIPTIONS}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          const activeSubscription = data.subscriptions?.find((sub: any) => sub.active) || data.subscriptions?.[0];
          const date = activeSubscription?.renewal_date || activeSubscription?.expires_at || null;
          setRenewalDate(date);
        }
      } catch (err) {
        console.error('Error loading subscription:', err);
      }
    };

    loadSubscription();
  }, []);

  return renewalDate;
}
